module.exports = __webpack_public_path__ + "static/lasers-b99ebcf0ef226ecfaf8e3b4a23b2ee4a.jpg";